import { render } from "./IconCollapse.vue?vue&type=template&id=7d256f82&lang=html"
import script from "./IconCollapse.vue?vue&type=script&lang=js"
export * from "./IconCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__